interface SingleColumnIconProps {
  size?: number;
}

const SingleColumnIcon: React.FC<SingleColumnIconProps> = ({ size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="4" width="12" height="16" rx="1" stroke="currentColor" strokeWidth="2" fill="none"/>
    </svg>
  );
};

export default SingleColumnIcon;
